
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexyuB_45OwWEAE0stpYO0FybbkTN_45IGxf2hZ5TzVHuDEe04Meta } from "/var/www/hotlot/web/pages/index.vue?macro=true";
import { default as contactJo24TxSeUx_WVRNFO9BKP_45bdwCbEdNX7ghgzdb4vz4oMeta } from "/var/www/hotlot/web/pages/contact.vue?macro=true";
import { default as favorites8Fjp26gCPuaIpUAoNnL9p_45Ifqp2b9dC4eBQkShPTXzoMeta } from "/var/www/hotlot/web/pages/favorites.vue?macro=true";
import { default as faqGYZpleqOPP1_45NB_45KZkR9ns8UwwN4QKKc9k81jIaT31oMeta } from "/var/www/hotlot/web/pages/legal/faq.vue?macro=true";
import { default as verifysJT8F2t33Pv2ixHFVPuugsXBJF7z_458rDz_456UXv_3PZkMeta } from "/var/www/hotlot/web/pages/auth/verify.vue?macro=true";
import { default as termsuTHcM_45FX4BFeSHRZV4I5neFLWuAhFmOKFVbXoBO5ucsMeta } from "/var/www/hotlot/web/pages/legal/terms.vue?macro=true";
import { default as how_45it_45works2URLMhA4vovkfXfq0ypP_45GZdjXf6wHPsGw6PSDOQ0XkMeta } from "/var/www/hotlot/web/pages/how-it-works.vue?macro=true";
import { default as _91id_93uVUoh6fCQMylY6_A_tgKyfdvdjUSiwgMPYi3G669VNcMeta } from "/var/www/hotlot/web/pages/auctions/[id].vue?macro=true";
import { default as _91id_93_M9zbF_459WGODqAhFGF3ME6snDH4uNF_45tJrPUAxbGbZoMeta } from "/var/www/hotlot/web/pages/products/[id].vue?macro=true";
import { default as indexMLIOWchY3hSOYiEGLRbqmBtvyZ_wYgsJBF_738_45FUcIMeta } from "/var/www/hotlot/web/pages/profile/index.vue?macro=true";
import { default as about_45usqe41P6bXTttrVM_WWGuW5dey5hO4hgORztQK6_45AKc3UMeta } from "/var/www/hotlot/web/pages/legal/about-us.vue?macro=true";
import { default as site_45maph5f7p4G_Al6Nv_jLSmyaO6Dn_45E3pUKemL0KUfHY1oMUMeta } from "/var/www/hotlot/web/pages/legal/site-map.vue?macro=true";
import { default as _91slug_93piKTeOif2JIvamq1rf_GhYGqPml6K52HlExPBz_bn0UMeta } from "/var/www/hotlot/web/pages/category/[slug].vue?macro=true";
import { default as how_45to_45bidn6sSrQZPTJzOLyxsv8kbcup7Dn4JaqdpL6uUhgg9FCMMeta } from "/var/www/hotlot/web/pages/legal/how-to-bid.vue?macro=true";
import { default as user_45guiderGZPf8e5gSFX1mw7XTC8Nx_6Mw6ZyCpAxn8ZJmBHWjQMeta } from "/var/www/hotlot/web/pages/legal/user-guide.vue?macro=true";
import { default as index96VRMzhCtdw62vuM5yRvw5dlUXJ0SXxaaVV626O1biYMeta } from "/var/www/hotlot/web/pages/profile/settings/index.vue?macro=true";
import { default as walletUTJWUYw6UAsQAyxTCLkXm2SY6VwPCZnsmI4ftEefM_kMeta } from "/var/www/hotlot/web/pages/profile/settings/wallet.vue?macro=true";
import { default as personalLdIxmcYcC8CXhgFX8f0OKSte3N5eO5w05WLCLvGex_45YMeta } from "/var/www/hotlot/web/pages/profile/settings/personal.vue?macro=true";
import { default as securityrOCRRlR3zNB5P6l7AWb5NgSzL0YyefuCZ8sRGimSI6gMeta } from "/var/www/hotlot/web/pages/profile/settings/security.vue?macro=true";
import { default as items_45wonhIwKnwVYf17_LoQnILNTdVeBNcfsQ1_45CEok84j7Afr4Meta } from "/var/www/hotlot/web/pages/profile/settings/items-won.vue?macro=true";
import { default as win_45historyiTtySVwolSFSrS7T_LPNCmom86LtKwS4Kd5KjIs7LxIMeta } from "/var/www/hotlot/web/pages/profile/settings/win-history.vue?macro=true";
import { default as bids_45historycMYzy4Kq1VX4AuNgzA6z4752tRfE267SxDqC3AFfDQwMeta } from "/var/www/hotlot/web/pages/profile/settings/bids-history.vue?macro=true";
import { default as notificationmeKHUSKql0eO1C_45iTlMC_45u5sJzFS8pukhPDrbaPB2QYMeta } from "/var/www/hotlot/web/pages/profile/settings/notification.vue?macro=true";
import { default as my_45active_45bidsRvOmxP2_45E0rlLApt9k_hBs2raD8yWa_45GS052euu6gJIMeta } from "/var/www/hotlot/web/pages/profile/settings/my-active-bids.vue?macro=true";
import { default as payment_45methodnoP8dt2P7vhQNB9YKVwYmYkrf6Yim19aQiaLU0QfMnwMeta } from "/var/www/hotlot/web/pages/profile/settings/payment-method.vue?macro=true";
import { default as pickup_45appointments8PmMtO5oCP6Dv8ylGICkKJhjX0KtKD4AptV38SivcKQMeta } from "/var/www/hotlot/web/pages/profile/settings/pickup-appointments.vue?macro=true";
import { default as settingsdCpamPhOsEowlaA1MrBS_fYGnQWHEoUWKhtp6M5_1QsMeta } from "/var/www/hotlot/web/pages/profile/settings.vue?macro=true";
import { default as seller_45guideKr8pwK0J8pvYddqTMUVrEFuTkHKuUmjVLiv5sP6tpwwMeta } from "/var/www/hotlot/web/pages/legal/seller-guide.vue?macro=true";
import { default as privacy_45policymh82rJuWC5UOzj6BjqqWNi9vzP1qTUU_eQqFHK6SZ4sMeta } from "/var/www/hotlot/web/pages/legal/privacy-policy.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/hotlot/web/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/var/www/hotlot/web/pages/contact.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    component: () => import("/var/www/hotlot/web/pages/favorites.vue")
  },
  {
    name: "legal-faq",
    path: "/legal/faq",
    component: () => import("/var/www/hotlot/web/pages/legal/faq.vue")
  },
  {
    name: "auth-verify",
    path: "/auth/verify",
    component: () => import("/var/www/hotlot/web/pages/auth/verify.vue")
  },
  {
    name: "legal-terms",
    path: "/legal/terms",
    component: () => import("/var/www/hotlot/web/pages/legal/terms.vue")
  },
  {
    name: "how-it-works",
    path: "/how-it-works",
    component: () => import("/var/www/hotlot/web/pages/how-it-works.vue")
  },
  {
    name: "auctions-id",
    path: "/auctions/:id()",
    component: () => import("/var/www/hotlot/web/pages/auctions/[id].vue")
  },
  {
    name: "products-id",
    path: "/products/:id()",
    component: () => import("/var/www/hotlot/web/pages/products/[id].vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/var/www/hotlot/web/pages/profile/index.vue")
  },
  {
    name: "legal-about-us",
    path: "/legal/about-us",
    component: () => import("/var/www/hotlot/web/pages/legal/about-us.vue")
  },
  {
    name: "legal-site-map",
    path: "/legal/site-map",
    component: () => import("/var/www/hotlot/web/pages/legal/site-map.vue")
  },
  {
    name: "category-slug",
    path: "/category/:slug()",
    component: () => import("/var/www/hotlot/web/pages/category/[slug].vue")
  },
  {
    name: "legal-how-to-bid",
    path: "/legal/how-to-bid",
    component: () => import("/var/www/hotlot/web/pages/legal/how-to-bid.vue")
  },
  {
    name: "legal-user-guide",
    path: "/legal/user-guide",
    component: () => import("/var/www/hotlot/web/pages/legal/user-guide.vue")
  },
  {
    name: settingsdCpamPhOsEowlaA1MrBS_fYGnQWHEoUWKhtp6M5_1QsMeta?.name,
    path: "/profile/settings",
    meta: settingsdCpamPhOsEowlaA1MrBS_fYGnQWHEoUWKhtp6M5_1QsMeta || {},
    component: () => import("/var/www/hotlot/web/pages/profile/settings.vue"),
    children: [
  {
    name: "profile-settings",
    path: "",
    meta: index96VRMzhCtdw62vuM5yRvw5dlUXJ0SXxaaVV626O1biYMeta || {},
    component: () => import("/var/www/hotlot/web/pages/profile/settings/index.vue")
  },
  {
    name: "profile-settings-wallet",
    path: "wallet",
    meta: walletUTJWUYw6UAsQAyxTCLkXm2SY6VwPCZnsmI4ftEefM_kMeta || {},
    component: () => import("/var/www/hotlot/web/pages/profile/settings/wallet.vue")
  },
  {
    name: "profile-settings-personal",
    path: "personal",
    component: () => import("/var/www/hotlot/web/pages/profile/settings/personal.vue")
  },
  {
    name: "profile-settings-security",
    path: "security",
    component: () => import("/var/www/hotlot/web/pages/profile/settings/security.vue")
  },
  {
    name: "profile-settings-items-won",
    path: "items-won",
    meta: items_45wonhIwKnwVYf17_LoQnILNTdVeBNcfsQ1_45CEok84j7Afr4Meta || {},
    component: () => import("/var/www/hotlot/web/pages/profile/settings/items-won.vue")
  },
  {
    name: "profile-settings-win-history",
    path: "win-history",
    meta: win_45historyiTtySVwolSFSrS7T_LPNCmom86LtKwS4Kd5KjIs7LxIMeta || {},
    component: () => import("/var/www/hotlot/web/pages/profile/settings/win-history.vue")
  },
  {
    name: "profile-settings-bids-history",
    path: "bids-history",
    meta: bids_45historycMYzy4Kq1VX4AuNgzA6z4752tRfE267SxDqC3AFfDQwMeta || {},
    component: () => import("/var/www/hotlot/web/pages/profile/settings/bids-history.vue")
  },
  {
    name: "profile-settings-notification",
    path: "notification",
    component: () => import("/var/www/hotlot/web/pages/profile/settings/notification.vue")
  },
  {
    name: "profile-settings-my-active-bids",
    path: "my-active-bids",
    meta: my_45active_45bidsRvOmxP2_45E0rlLApt9k_hBs2raD8yWa_45GS052euu6gJIMeta || {},
    component: () => import("/var/www/hotlot/web/pages/profile/settings/my-active-bids.vue")
  },
  {
    name: "profile-settings-payment-method",
    path: "payment-method",
    component: () => import("/var/www/hotlot/web/pages/profile/settings/payment-method.vue")
  },
  {
    name: "profile-settings-pickup-appointments",
    path: "pickup-appointments",
    meta: pickup_45appointments8PmMtO5oCP6Dv8ylGICkKJhjX0KtKD4AptV38SivcKQMeta || {},
    component: () => import("/var/www/hotlot/web/pages/profile/settings/pickup-appointments.vue")
  }
]
  },
  {
    name: "legal-seller-guide",
    path: "/legal/seller-guide",
    component: () => import("/var/www/hotlot/web/pages/legal/seller-guide.vue")
  },
  {
    name: "legal-privacy-policy",
    path: "/legal/privacy-policy",
    component: () => import("/var/www/hotlot/web/pages/legal/privacy-policy.vue")
  }
]